'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Base = require('../Base');

var _Base2 = _interopRequireDefault(_Base);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hotel = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Hotel, _Component);

  function Hotel() {
    (0, _classCallCheck3.default)(this, Hotel);
    return (0, _possibleConstructorReturn3.default)(this, (Hotel.__proto__ || (0, _getPrototypeOf2.default)(Hotel)).apply(this, arguments));
  }

  (0, _createClass3.default)(Hotel, [{
    key: 'render',
    value: function render() {
      var props = (0, _extends3.default)({}, this.props, {
        width: parseInt(this.props.width, 10),
        height: parseInt(this.props.height, 10)
      });

      return _react2.default.createElement(
        _Base2.default,
        (0, _extends3.default)({ viewBox: '0 27 60 10' }, props),
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement('path', { xmlns: 'http://www.w3.org/2000/svg', fill: props.fillWheel1 || props.fill, d: 'M35.968 1.28c-1.472 0-2.624 1.216-2.624 2.624v56.128c0 1.472 1.152 2.688 2.624 2.688h21.568c1.472 0 2.624-1.216 2.624-2.688v-56.128c0-1.472-1.216-2.624-2.624-2.624h-21.568zM37.696 5.12h6.4c0.384 0 0.64 0.32 0.64 0.64v5.312c0 0.384-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.32-0.64-0.64v-5.312c0-0.32 0.256-0.64 0.64-0.64zM37.696 14.528h6.4c0.384 0 0.64 0.32 0.64 0.64v5.312c0 0.384-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.256-0.64-0.64v-5.312c0-0.32 0.256-0.64 0.64-0.64zM37.696 24h6.4c0.384 0 0.64 0.256 0.64 0.64v5.248c0 0.384-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.256-0.64-0.64v-5.248c0-0.384 0.256-0.64 0.64-0.64zM37.696 33.408h6.4c0.384 0 0.64 0.32 0.64 0.64v5.312c0 0.32-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.32-0.64-0.64v-5.312c0-0.32 0.256-0.64 0.64-0.64zM37.696 42.88h6.4c0.384 0 0.64 0.32 0.64 0.64v5.312c0 0.384-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.256-0.64-0.64v-5.312c0-0.384 0.256-0.64 0.64-0.64zM37.696 52.288h6.4c0.384 0 0.64 0.256 0.64 0.64v5.312c0 0.32-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.32-0.64-0.64v-5.248c0-0.448 0.256-0.704 0.64-0.704zM48.96 5.12h6.4c0.32 0 0.64 0.32 0.64 0.64v5.312c0 0.384-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.32-0.64-0.64v-5.312c0-0.32 0.32-0.64 0.64-0.64zM48.96 14.528h6.4c0.32 0 0.64 0.32 0.64 0.64v5.312c0 0.384-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.256-0.64-0.64v-5.312c0-0.32 0.32-0.64 0.64-0.64zM48.96 24h6.4c0.32 0 0.64 0.256 0.64 0.64v5.248c0 0.384-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.256-0.64-0.64v-5.248c0-0.384 0.32-0.64 0.64-0.64zM48.96 33.408h6.4c0.32 0 0.64 0.32 0.64 0.64v5.312c0 0.32-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.32-0.64-0.64v-5.312c0-0.32 0.32-0.64 0.64-0.64zM48.96 42.88h6.4c0.32 0 0.64 0.32 0.64 0.64v5.312c0 0.384-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.256-0.64-0.64v-5.312c0-0.384 0.32-0.64 0.64-0.64zM48.96 52.288h6.4c0.32 0 0.64 0.256 0.64 0.64v5.312c0 0.32-0.32 0.64-0.64 0.64h-6.4c-0.32 0-0.64-0.32-0.64-0.64v-5.248c0-0.448 0.32-0.704 0.64-0.704z' }),
          _react2.default.createElement('path', { xmlns: 'http://www.w3.org/2000/svg', fill: props.fillWheel1 || props.fill, d: 'M19.392 33.408c-0.32 0-0.64 0.32-0.64 0.64v5.312c0 0.32 0.256 0.64 0.64 0.64h6.4c0.32 0 0.64-0.32 0.64-0.64v-5.312c0-0.384-0.32-0.64-0.64-0.64h-6.4zM19.392 42.88c-0.32 0-0.64 0.32-0.64 0.64v5.312c0 0.384 0.256 0.64 0.64 0.64h6.4c0.32 0 0.64-0.256 0.64-0.64v-5.312c0-0.32-0.32-0.64-0.64-0.64h-6.4zM19.392 52.288c-0.32 0-0.64 0.256-0.64 0.64v5.312c0 0.32 0.256 0.64 0.64 0.64h6.4c0.32 0 0.64-0.32 0.64-0.64v-5.248c0-0.384-0.32-0.64-0.64-0.64h-6.4zM8.128 33.408c-0.384 0-0.64 0.32-0.64 0.64v5.312c0 0.32 0.256 0.64 0.64 0.64h6.4c0.384 0 0.64-0.32 0.64-0.64v-5.312c0-0.384-0.256-0.64-0.64-0.64h-6.4zM8.128 42.88c-0.384 0-0.64 0.32-0.64 0.64v5.312c0 0.384 0.256 0.64 0.64 0.64h6.4c0.384 0 0.64-0.256 0.64-0.64v-5.312c0-0.32-0.256-0.64-0.64-0.64h-6.4zM8.128 52.288c-0.384 0-0.64 0.256-0.64 0.64v5.312c0 0.32 0.256 0.64 0.64 0.64h6.4c0.384 0 0.64-0.32 0.64-0.64v-5.248c0-0.384-0.256-0.64-0.64-0.64h-6.4zM6.464 29.632h21.568c1.472 0 2.624 1.216 2.624 2.688v27.776c0 1.472-1.152 2.688-2.624 2.688h-21.568c-1.472 0-2.624-1.216-2.624-2.688v-27.776c-0.064-1.472 1.152-2.688 2.624-2.688z' })
        )
      );
    }
  }]);
  return Hotel;
}(_react.Component), _class.propTypes = {
  width: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  height: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
  fill: _react.PropTypes.string,
  fillWheel1: _react.PropTypes.string,
  fillWheel2: _react.PropTypes.string,
  className: _react.PropTypes.string
}, _class.defaultProps = {
  width: 16,
  height: 16,
  fill: '#848484'
}, _temp);
exports.default = Hotel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/enterprise/EnterpriseIcons/Hotel/Hotel.jsx
// module id = 1593
// module chunks = 0